import * as React from "react"

function OrderFieldSvg (props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={92.664}
            height={60}
            viewBox="0 0 52.664 52.769"
            {...props}
        >
            <g data-name="Group 1673" fill="#b5b5c3" stroke="#fff">
                <path
                    data-name="Path 26239"
                    d="M41.168 27.51a8.954 8.954 0 01.906.768 1 1 0 01-.009 1.4.937.937 0 01-1.384.051q-1.394-1.3-2.717-2.672a.918.918 0 010-1.347 72.783 72.783 0 012.687-2.7.978.978 0 011.4.054 1 1 0 01.032 1.4 7.055 7.055 0 01-.778.68l.085.208c.552-.052 1.109-.076 1.656-.16a8.207 8.207 0 007.037-8.725 8.293 8.293 0 00-8.243-7.689c-2.041-.013-4.082 0-6.208 0v2.794a3.127 3.127 0 01-3.408 3.417H20.41a3.122 3.122 0 01-3.38-3.38V3.847a3.111 3.111 0 013.343-3.35h11.943a3.1 3.1 0 013.312 3.316c.005.943 0 1.886 0 2.895 1.134 0 2.2-.028 3.272.006a33.021 33.021 0 015.074.266 10.285 10.285 0 01-.156 20.167c-.789.163-1.599.226-2.65.363zM26.338 2.57h-5.876c-1.017 0-1.358.341-1.359 1.354v7.7c0 .928.361 1.3 1.285 1.3q5.941.006 11.882 0c.929 0 1.293-.364 1.3-1.289q.007-3.882 0-7.764c0-.931-.362-1.294-1.287-1.3-1.984-.002-3.964.002-5.945.002z"
                />
                <path
                    data-name="Path 26240"
                    d="M17.035 25.346c0-1.051-.006-2.018 0-2.985a3.09 3.09 0 013.212-3.221q6.133-.013 12.267 0a3.064 3.064 0 013.111 3.055q.038 4.172 0 8.345a3.056 3.056 0 01-3.08 3.086q-6.23.029-12.46 0a3.069 3.069 0 01-3.046-3.056c-.021-1.029 0-2.058 0-3.077-2.466 0-4.868-.005-7.271.007a3.705 3.705 0 00-.823.149 8.241 8.241 0 00.774 16.2 6.264 6.264 0 001.617.042c-.217-.217-.441-.427-.65-.651a1.047 1.047 0 01-.05-1.55 1.027 1.027 0 011.5.062q1.226 1.2 2.414 2.429a1.049 1.049 0 010 1.691c-.766.788-1.541 1.567-2.331 2.33-.584.564-1.2.585-1.639.1-.416-.46-.346-1.043.2-1.593.178-.177.38-.33.631-.544-1.086-.168-2.045-.253-2.972-.471a10.281 10.281 0 011.025-20.21c1.87-.218 3.78-.1 5.672-.133.607-.013 1.207-.005 1.899-.005zm9.259 6.212h5.939c.974 0 1.328-.352 1.33-1.32q.008-3.848 0-7.7c0-.978-.347-1.327-1.318-1.327H20.432c-.976 0-1.327.349-1.328 1.319q-.007 3.848 0 7.7c0 .977.349 1.327 1.317 1.329h5.871z"
                />
                <path
                    data-name="Path 26241"
                    d="M26.367 37.773h5.939a3.11 3.11 0 013.329 3.3q.007 3.945 0 7.891a3.1 3.1 0 01-3.327 3.3q-5.971.006-11.942 0a3.1 3.1 0 01-3.327-3.3q-.014-3.978 0-7.955a3.1 3.1 0 013.262-3.235c1.011-.005 2.023 0 3.034 0zm-.089 12.424h6.005c.92 0 1.28-.369 1.282-1.3q.006-3.882 0-7.764c0-.919-.368-1.282-1.3-1.283H20.383c-.922 0-1.28.365-1.281 1.3q-.006 3.882 0 7.764c0 .924.366 1.282 1.3 1.284 1.959.002 3.918-.001 5.876-.001z"
                />
                <path
                    data-name="Path 26242"
                    d="M11.25 8.784H1.769c-.8-.006-1.276-.412-1.26-1.059.016-.628.471-1.007 1.245-1.008q4.42-.008 8.84-.005h.816c-.3-.308-.514-.52-.718-.743a1.048 1.048 0 01-.054-1.55 1.023 1.023 0 011.5.063q1.252 1.213 2.457 2.474a1.016 1.016 0 010 1.595q-1.165 1.209-2.374 2.376c-.584.564-1.2.586-1.638.1-.416-.459-.348-1.044.2-1.592.178-.178.381-.329.573-.493z"
                />
                <path
                    data-name="Path 26243"
                    d="M26.351 10.855h-3.93c-.792 0-1.267-.42-1.248-1.069.019-.625.473-1 1.249-1q3.9-.006 7.8 0c.813 0 1.282.388 1.281 1.035s-.474 1.033-1.282 1.036c-1.289.005-2.577 0-3.866 0z"
                />
                <path
                    data-name="Path 26244"
                    d="M28.384 4.644c.664 0 1.329-.012 1.993 0a1.034 1.034 0 110 2.061 176.63 176.63 0 01-3.987 0 1.031 1.031 0 110-2.059c.665-.016 1.33-.002 1.994-.002z"
                />
                <path
                    data-name="Path 26245"
                    d="M22.202 6.711a1.032 1.032 0 111.031-1.016 1.046 1.046 0 01-1.031 1.016z"
                />
                <path
                    data-name="Path 26246"
                    d="M26.333 29.494h-3.874c-.812 0-1.286-.393-1.286-1.038s.471-1.032 1.286-1.033q3.875-.005 7.749 0c.814 0 1.287.388 1.287 1.034s-.475 1.031-1.288 1.034h-3.874z"
                />
                <path
                    data-name="Path 26247"
                    d="M28.394 25.352c-.646 0-1.292.011-1.937 0a1.04 1.04 0 11.015-2.067q1.937-.018 3.874 0a1.04 1.04 0 11-.015 2.067c-.646.012-1.291 0-1.937 0z"
                />
                <path
                    data-name="Path 26248"
                    d="M22.175 25.344a1.03 1.03 0 111.054-1 1.04 1.04 0 01-1.054 1z"
                />
                <path
                    data-name="Path 26249"
                    d="M25.285 45.771l3.457-3.371c.169-.165.327-.344.506-.5a1.035 1.035 0 011.4-.008 1.014 1.014 0 01.054 1.45c-.191.232-.415.437-.628.649-1.313 1.3-2.615 2.618-3.945 3.9-.659.637-1.055.621-1.715-.016a106.411 106.411 0 01-2.328-2.327 1.038 1.038 0 01-.07-1.589 1.067 1.067 0 011.545.141z"
                />
            </g>
        </svg>
    )
}

export default OrderFieldSvg
